import React from 'react';
import { Description } from './styled';
import Link from '@/presentation/reusables/Link';

export const idOfTheStudent = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>Carga tu DNI por ambas caras.</li>
    </ul>
  </Description>
);

export const familyId = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Soltero(a):</b> Carga el DNI de tu papá, mamá y hermanos (as) con los
        que vives.
      </li>
      <li>
        <b>Casado(a) o conviviente:</b> Carga el DNI del cónyuge o conviviente y
        el DNI de los(as) hijos(as) con los que vives.
      </li>
      <li>
        <b>Divorciado(a):</b> Carga el DNI de los(as) hijos(as) (si los
        tuvieras).
      </li>
    </ul>
  </Description>
);

export const recordsOfYourFamily = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Casado(a):</b> Carga la partida de tu matrimonio.
      </li>
      <li>
        <b>Conviviente:</b> Carga la declaración jurada simple de convivencia.
      </li>
      <li>
        <b>Divorciado(a):</b> Carga el acta de divorcio.
      </li>
    </ul>
  </Description>
);

export const income = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Dependientes:</b> Carga la última boleta de pago de haberes.
      </li>
      <li>
        <b>Independiente:</b> Carga el último recibo por honorarios.
      </li>
      <li>
        <b>Trabajos informales:</b> Carga la declaración jurada simple de
        ingresos.
      </li>
    </ul>
  </Description>
);

export const employmentSituation = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Reducción de sueldo:</b> Carga la adenda de reducción de sueldo.
      </li>
      <li>
        <b>Cese de trabajo:</b> Carga la constancia de cese laboral y constancia
        de liquidación.
      </li>
    </ul>
  </Description>
);

export const housingStatus = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Propia:</b> Carga el último pago efectuado de hipoteca, omite este
        paso y pasa al siguiente.
      </li>
      <li>
        <b>Alquilada:</b> Carga el contrato de alquiler o recibo de pago de
        alquiler.
      </li>
      <li>
        <b>Otra situación:</b> Carga la declaración jurada simple de la
        situación de tu vivienda actual y 3 fotos:
        <ol>
          <li>Frontal (Fachada) de la casa.</li>
          <li>La cocina.</li>
          <li>La sala.</li>
        </ol>
      </li>
    </ul>
  </Description>
);

export const housingServices = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Propia o alquilada:</b> Carga los últimos recibos de agua y luz que
        se han pagado en el hogar.
      </li>
      <li>
        <b>Otra situación:</b> Si no estás en una vivienda propia o alquilada,
        carga la declaración jurada simple de costos de servicios.
      </li>
    </ul>
  </Description>
);

export const healthExpenses = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Tratamiento médico:</b> Carga informe médico y la constancia de los
        gastos de salud.
      </li>
      <br />
      <li style={{ listStyleType: 'none' }}>
        (*) Si no es tu caso: Omite este paso y avanza al siguiente.
      </li>
    </ul>
  </Description>
);

export const financialState = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>Carga el Reporte de Sentinel del responsable de pagos del hogar.</li>
    </ul>
    <span>
      Puedes generarlo aquí:{' '}
      <Link
        linkType="external"
        url="https://www.misentinel.com.pe/usuario/login"
        linkName="https://www.misentinel.com.pe/usuario/login"
      />
    </span>
  </Description>
);

export const generalDebts = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Con el Banco:</b> Carga el último estado de cuenta de las tarjetas de
        crédito y/o cronograma de pago de préstamo.
      </li>
      <li>
        <b>Con una persona Natural:</b> Carga la declaración jurada simple de
        deuda contraida.
      </li>
      <br />
      <li style={{ listStyleType: 'none' }}>
        (*) Si no es tu caso: Omite este paso y avanza al siguiente.
      </li>
    </ul>
  </Description>
);

export const educationExpenditure = () => (
  <Description>
    <span>Adjunta lo siguiente:</span>
    <ul>
      <li>
        <b>Familiares estudiando:</b> Carga la constancia de gastos en
        educación, tuya y de tus familiares, ya sean padres, hijos(as), cónyuge
        y/o hermanos(as) que estén estudiando.
      </li>
      <br />
      <li style={{ listStyleType: 'none' }}>
        (*) Si no es tu caso: Omite este paso y avanza al siguiente.
      </li>
    </ul>
  </Description>
);

export const additionalInformation = () => (
  <Description>
    <span>
      Si deseas presentar <b>documentación adicional</b> que consideres{' '}
      <b>importante</b> para la evaluación de tu solicitud, puedes adjuntarlas
      aquí.
    </span>
  </Description>
);
